import { useState } from 'react'

export interface UseDrawerStateReturn {
  open: boolean
  show: () => void
  hide: () => void
}

interface UseDrawerStateParams {
  open?: boolean
}

export function useDrawerState(
  params?: UseDrawerStateParams
): UseDrawerStateReturn {
  const [open, setOpen] = useState(params?.open ?? false)

  function show() {
    setOpen(true)
  }

  function hide() {
    setOpen(false)
  }

  return {
    open,
    show,
    hide,
  }
}
